// import JsBarcode from 'jsbarcode' 
import Store from '@/store'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const returnSalarySheet  = async (base64Logo, vm) => {
  try {
    Store.commit('mutateCommonProperties', {
      loading: true
    })

    const pdfContent = [
      { image: 'data:image/png;base64,' + base64Logo, height: 70, width: 70, style: 'logo', alignment: 'left' },
      { text: 'Salary of ' + vm.month_name + ', ' + vm.year, style: 'org', alignment: 'left' },
      { text: 'Total Rider : ' + vm.total_rider + ', Total Salary : ' + vm.total_salary, style: 'org', alignment: 'right' }
    ]

    pdfContent.push({ text: '', style: 'space' })

    const allRows = [
      [
        { text: 'SL', style: 'th', alignment: 'center', bold: true },
        { text: 'Rider Name', style: 'th', alignment: 'center', bold: true },
        { text: 'Rider Mobile', style: 'th', alignment: 'center', bold: true },
        { text: 'Total Order', style: 'th', alignment: 'center', bold: true },
        { text: 'Advacned Amount', style: 'th', alignment: 'center', bold: true },
        { text: 'Salary', style: 'th', alignment: 'center', bold: true },
        { text: 'Final Amount', style: 'th', alignment: 'center', bold: true }
      ]
    ]

    vm.salaries.forEach((item, index) => {
      allRows.push([
          { text: index+1, alignment: 'center', style: 'td' },
          { text: item.rider_name, alignment: 'center', style: 'td' },
          { text: item.rider_mobile, alignment: 'center', style: 'td' },
          { text: item.total_order, alignment: 'center', style: 'td' },
          { text: item.salary_advanced, alignment: 'center', style: 'td' },
          { text: item.salary, alignment: 'center', style: 'td' },
          { text: item.final_amount, alignment: 'center', style: 'td' }
      ])
    })

    pdfContent.push({
        table: {
            headerRows: 1,
            widths: '*',
            body: allRows
        }
    })

    var docDefinition = {
      content: pdfContent,
      pageSize: 'A4',
      pageOrientation: 'landscape',
      footer: function (currentPage, pageCount) {
        return {
          table: {
            body: [
                [
                  { text: "Page " + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', /*margin: [0, 0, 0, 0]*/ }
                ]
            ]
          }
        };
      },
      styles: {
        th: {
          fontSize: 8,
          margin: [3, 3, 3, 3]
        },
        td: {
          fontSize: 8,
          margin: [3, 3, 3, 3]
        },
        space: {
          margin: [5, 0, 0, 5]
        },
        header: {
          fontSize: 17,
          bold: true,
          margin: [0, 5, 0, 0]
        },
        logo: {
          margin: [0, 0, 0, 10]
        },
        normalText: {
          border: 0
        },
        hh: {
          fontSize: 13,
          bold: true,
          margin: [10, 10, 25, 20]
        }
      }
    }
    pdfMake.createPdf(docDefinition, null, null, null).print()
  } catch (error) {
    if (error) {
      console.log('err => ', error)
    }
  }
  Store.commit('mutateCommonProperties', {
    loading: false
  })
}

// function generateBarcode (orderNo) {
//   let canvas = document.createElement('canvas');
//   JsBarcode(canvas, orderNo, { 
//       format: 'CODE39',
//       displayValue: false,
//       height: 15,
//       width: 1,
//       padding: 0,
//       margin: 0
//   });
//   return canvas.toDataURL('image/png');
// }

export default {
    returnSalarySheet 
}
